export const lbsToKg = (lbs: number) => lbs * 0.45359237;

// Imperial height is entered as decimal feet (e.g. 5.6 ft)
export const feetToCm = (feet: number) => feet * 30.48;

/**
 * Parses a numeric-only input string.
 * Supports decimals and commas.
 */
export const parseNumber = (raw: string) => {
  const n = Number(String(raw).trim().replace(",", "."));
  return Number.isFinite(n) ? n : null;
};

/**
 * Converts weight to kilograms.
 * - Metric input: kg
 * - Imperial input: lbs
 */
export const toMetricWeightKg = (raw: string, unit: "metric" | "imperial") => {
  const n = parseNumber(raw);
  if (n == null) return null;

  return unit === "metric" ? n : lbsToKg(n);
};

/**
 * Converts height to centimeters.
 * - Metric input: cm
 * - Imperial input: decimal feet (e.g. 5.8)
 */
export const toMetricHeightCm = (raw: string, unit: "metric" | "imperial") => {
  const n = parseNumber(raw);
  if (n == null) return null;

  return unit === "metric" ? n : feetToCm(n);
};
